import React from "react";

import cx from "classnames";
import Markdown from "markdown-to-jsx";

import styles from "./css/SummaryText.module.css";

const SUMMARY_MARKDOWN_OPTIONS: React.ComponentProps<typeof Markdown>["options"] = {
	disableParsingRawHTML: true,
	forceInline: false,
	overrides: {
		img: {
			component: props => <>{props.title ?? props.src}</>,
		},
		a: {
			component: props => <>{props.href}</>,
		},
		h1: { component: "p" },
		h2: { component: "p" },
		h3: { component: "p" },
		h4: { component: "p" },
		h5: { component: "p" },
		h6: { component: "p" },
	},
};

export function SummaryText({
	children,
	bulletPointLimit,
	className,
}: {
	children: string;
	bulletPointLimit?: number;
	className?: string;
}) {
	const lines = children.split("\n");
	const limit = bulletPointLimit === undefined ? undefined : bulletPointLimit + 1;
	const isLimited = limit !== undefined && lines.length > limit;
	let truncatedText = lines.slice(0, limit).join("\n");
	if (isLimited) while (truncatedText.endsWith(".")) truncatedText = truncatedText.slice(0, -1);

	return (
		<div className={cx(styles.paragraph, className)}>
			<Markdown options={SUMMARY_MARKDOWN_OPTIONS}>{truncatedText}</Markdown>
			{isLimited && <span className={styles.moreText}>… more</span>}
		</div>
	);
}
